import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var UploadIcon = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(SvgIcon, __assign({}, props, { viewBox: "0 0 12 15" }),
        React.createElement("path", { d: "M4.28571 10.7936H7.71429C8.18571 10.7936 8.57143 10.4079 8.57143 9.93643V5.65071H9.93429C10.6971 5.65071 11.0829 4.725 10.5429 4.185L6.60857 0.250714C6.27429 -0.0835714 5.73429 -0.0835714 5.4 0.250714L1.46571 4.185C0.925714 4.725 1.30286 5.65071 2.06571 5.65071H3.42857V9.93643C3.42857 10.4079 3.81429 10.7936 4.28571 10.7936ZM0.857143 12.5079H11.1429C11.6143 12.5079 12 12.8936 12 13.365C12 13.8364 11.6143 14.2221 11.1429 14.2221H0.857143C0.385714 14.2221 0 13.8364 0 13.365C0 12.8936 0.385714 12.5079 0.857143 12.5079Z" })));
};

export { UploadIcon };
//# sourceMappingURL=UploadIcon.esm.js.map
